import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoalResponseDto } from '../../../store/landscapeAPI/goal/dto/response/goal-response.dto';
import { Action, Label, TableRow } from '../../atoms';
import { SortableTable } from '../../molecules';

//import styles from './ReportingDetailsGoalsOrganism.module.css';

interface ReportingDetailsGoalsOrganismProps {
  data: GoalResponseDto[];
  handleDeleteGoal: (id: string) => void;
}

const ReportingDetailsGoalsOrganism: FC<ReportingDetailsGoalsOrganismProps> = ({
  data,
  handleDeleteGoal,
}) => {
  const navigate = useNavigate();

  const handleUpdateGoal = (id: string) => {
    navigate(`/reporting-details/goals/${id}/edit`);
  };

  return (
    <SortableTable
      data={data}
      columns={[
        { label: 'Goals', key: 'name' },
        { label: 'Type', key: 'type' },
      ]}
      renderRow={(row) => (
        <TableRow key={row.id}>
          <Label content={row.name}></Label>
          <Label content={row.type.toString()}></Label>

          <Action
            type="edit"
            size="sm"
            onClick={() => handleUpdateGoal(row.id)}
          ></Action>
          <Action
            type="delete"
            itemName={row.name}
            size="sm"
            onClick={() => handleDeleteGoal(row.id)}
          ></Action>
        </TableRow>
      )}
    />
  );
};

export default ReportingDetailsGoalsOrganism;
